import React from "react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Download } from "lucide-react";
import { formatINR } from "@/lib/api";

export const CustomerLedgerDialog = ({ open, onClose, shop, ledger, onDownload }) => (
  <Dialog open={open} onOpenChange={onClose}>
    <DialogContent data-testid="ledger-dialog" className="max-w-2xl">
      <DialogHeader><DialogTitle className="flex items-center justify-between pr-6">
        <span>Statement of Account — {shop?.shop_name}</span>
        {shop && <Button data-testid="ledger-download-pdf" size="sm" variant="outline" className="gap-1" onClick={() => onDownload(shop)}><Download className="h-3.5 w-3.5" /> PDF</Button>}
      </DialogTitle></DialogHeader>
      {!ledger ? <p className="text-sm text-muted-foreground py-6 text-center">Loading...</p> : (
        <>
          <div className="grid grid-cols-3 gap-2 mb-2">
            <div className="rounded-lg bg-[#F7F0E6] border border-border p-3 text-center"><div className="text-xs text-muted-foreground">Total Debit</div><div className="font-mono text-sm">{formatINR(ledger.total_debit)}</div></div>
            <div className="rounded-lg bg-[#F7F0E6] border border-border p-3 text-center"><div className="text-xs text-muted-foreground">Total Credit</div><div className="font-mono text-sm">{formatINR(ledger.total_credit)}</div></div>
            <div className="rounded-lg bg-[#F7F0E6] border border-border p-3 text-center"><div className="text-xs text-muted-foreground">Closing Balance</div><div data-testid="ledger-closing-balance" className="font-mono text-sm text-[hsl(var(--primary))]">{formatINR(ledger.closing_balance)}</div></div>
          </div>
          <div className="max-h-96 overflow-y-auto">
            {ledger.entries.length === 0 ? <p className="text-sm text-muted-foreground py-6 text-center">No transactions yet.</p> : (
              <Table>
                <TableHeader><TableRow><TableHead>Date</TableHead><TableHead>Description</TableHead><TableHead className="text-right">Debit</TableHead><TableHead className="text-right">Credit</TableHead><TableHead className="text-right">Balance</TableHead></TableRow></TableHeader>
                <TableBody>
                  {ledger.entries.map((e, i) => (
                    <TableRow key={`${e.ref || "row"}-${e.type || ""}-${e.date || ""}-${i}`}>
                      <TableCell className="text-xs">{(e.date || "").slice(0, 10)}</TableCell>
                      <TableCell className="text-sm">{e.description}</TableCell>
                      <TableCell className="text-right font-mono text-sm">{e.debit ? formatINR(e.debit) : "-"}</TableCell>
                      <TableCell className="text-right font-mono text-sm text-[#1F5B2E]">{e.credit ? formatINR(e.credit) : "-"}</TableCell>
                      <TableCell className="text-right font-mono text-sm">{formatINR(e.balance)}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            )}
          </div>
        </>
      )}
    </DialogContent>
  </Dialog>
);
